export const DEFAULT_SEARCH_DELAY = 350
